import { Sparkles } from 'lucide-react';

import { definePanel } from '@/app/definePanel';

export default definePanel({
    id: 'ai_chat',
    title: 'AI Chat',
    icon: Sparkles,
    modes: ['view', 'settings'],
    themes: 'any',
    isHeaderless: true, // chat panel renders its own minimal header (× overlay)
    // Sits directly on the page bg — no card fill / rounding / shadow
    // (Figma 559:10873).
    isTransparent: true,
    // Chat is hosted by the shell drawer and has its own pixel width model.
    isOffStage: true,
    order: 1, // leftmost
});
